export const baseUrl = "https://paramall.tn/";